<div class="container">
    <div class="loggedin-user-header">Angemeldeter Benutzer:</div>
    <div class="account" *ngIf="authData != null">
        <i class="icon-head"></i>
        <span class="phone">{{authData.phone}}</span>
        <span class="email">{{authData.email}}</span>
    </div>
    <button class="btn btn-danger logout-button" href="" (click)="logout()">Abmelden</button>
</div>